import { Link, useLocation } from "@/lib/router-compat";
import { Home, Video, Podcast, Globe, User } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/context/AuthContext";
import { useProfile } from "@/hooks/useProfile";
import { ProfileAvatar } from "@/components/ui/ProfileAvatar";
import { useT } from "@/i18n/useLocale";

const MobileTabBar = () => {
  const location = useLocation();
  const { user, isAuthenticated } = useAuth();
  const { profile } = useProfile();
  const t = useT();
  
  const tabs = [
    { to: "/", icon: Home, label: t("nav.news") },
    { to: "/social", icon: Video, label: t("nav.social") },
    { to: "/markets", icon: Globe, label: t("nav.markets") },
    { to: "/podcasts", icon: Podcast, label: t("nav.podcasts") },
    { to: "/profile", icon: User, label: t("nav.profile"), isProfile: true },
  ];
  
  return (
    <nav className="fixed z-50 bottom-0 left-0 right-0 h-16 bg-background border-t flex items-center justify-around shadow-card md:hidden">
      {tabs.map(tab => {
        const active = location.pathname === tab.to || (tab.to === '/profile' && location.pathname.startsWith('/profile'));
        const Icon = tab.icon;
        
        // Special rendering for profile tab with avatar
        if (tab.isProfile && isAuthenticated && user) {
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={cn(
                "flex flex-col items-center justify-center text-xs flex-1 py-2 transition-colors",
                active ? "text-foreground font-semibold" : "text-muted-foreground"
              )}
              aria-label={tab.label}
            >
              <ProfileAvatar
                userId={user.id}
                avatarUrl={profile?.avatar_url || user.user_metadata?.avatar_url}
                name={profile?.full_name || profile?.username || user.email}
                size="xs"
                className="h-6 w-6 mb-1 text-[10px]"
              />
              <span className="text-xs">{tab.label}</span>
            </Link>
          );
        }
        
        return (
          <Link
            key={tab.to}
            to={tab.to}
            className={cn(
              "flex flex-col items-center justify-center text-xs flex-1 py-2 hover:font-semibold transition-colors",
              active ? "text-foreground font-semibold" : "text-muted-foreground"
            )}
            aria-label={tab.label}
          >
            <Icon className={cn("h-6 w-6 mb-1", active ? "stroke-2 text-primary-strong" : "opacity-70")} />
            <span className="text-xs">{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default MobileTabBar;
